import React from 'react'

const IVRIllustration = () => {
  return (
    <svg
      viewBox="0 0 500 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      {/* Background circles */}
      <circle cx="250" cy="200" r="140" fill="#B3E5F5" opacity="0.3" />
      <circle cx="250" cy="200" r="100" fill="#80D4E8" opacity="0.4" />
      
      {/* Center Phone Icon */}
      <g transform="translate(250, 200)">
        {/* Phone body */}
        <rect x="-40" y="-60" width="80" height="120" rx="12" fill="#164be8ff" />
        <rect x="-35" y="-52" width="70" height="90" rx="6" fill="#2C3E50" />
        
        {/* Speaker */}
        <rect x="-20" y="-45" width="40" height="4" rx="2" fill="#4A5B6D" />
        
        {/* Menu items on screen */}
        <rect x="-25" y="-30" width="50" height="8" rx="2" fill="#222122b7" />
        <rect x="-25" y="-15" width="50" height="8" rx="2" fill="#222122b7" />
        <rect x="-25" y="0" width="50" height="8" rx="2" fill="#222122b7" />
        <rect x="-25" y="15" width="50" height="8" rx="2" fill="#164be8ff" />
        
        {/* Home button */}
        <circle cx="0" cy="50" r="8" fill="#2e59d9" />
      </g>
      
      {/* Sound waves - Left */}
      <g opacity="0.7">
        <path d="M 130 200 Q 120 180 110 200 Q 120 220 130 200" stroke="#164be8ff" strokeWidth="4" fill="none" strokeLinecap="round" />
        <path d="M 110 200 Q 95 170 80 200 Q 95 230 110 200" stroke="#164be8ff" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.7" />
        <path d="M 90 200 Q 70 155 50 200 Q 70 245 90 200" stroke="#164be8ff" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5" />
      </g>
      
      {/* Sound waves - Right */}
      <g opacity="0.7">
        <path d="M 370 200 Q 380 180 390 200 Q 380 220 370 200" stroke="#164be8ff" strokeWidth="4" fill="none" strokeLinecap="round" />
        <path d="M 390 200 Q 405 170 420 200 Q 405 230 390 200" stroke="#164be8ff" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.7" />
        <path d="M 410 200 Q 430 155 450 200 Q 430 245 410 200" stroke="#164be8ff" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5" />
      </g>
      
      {/* IVR Flow Nodes - Top */}
      <g transform="translate(250, 70)">
        <circle r="30" fill="#222122b7" opacity="0.8" />
        <text x="0" y="8" textAnchor="middle" fill="white" fontSize="24" fontWeight="bold">1</text>
      </g>
      
      {/* Connection lines */}
      <line x1="250" y1="100" x2="250" y2="140" stroke="#222122b7" strokeWidth="3" opacity="0.6" strokeDasharray="5,5" />
      
      {/* IVR Flow Nodes - Bottom Left */}
      <g transform="translate(150, 330)">
        <circle r="25" fill="#222122b7" opacity="0.7" />
        <text x="0" y="6" textAnchor="middle" fill="white" fontSize="20" fontWeight="bold">2</text>
      </g>
      
      {/* IVR Flow Nodes - Bottom Right */}
      <g transform="translate(350, 330)">
        <circle r="25" fill="#222122b7" opacity="0.7" />
        <text x="0" y="6" textAnchor="middle" fill="white" fontSize="20" fontWeight="bold">3</text>
      </g>
      
      {/* Connection lines from center to bottom nodes */}
      <line x1="230" y1="250" x2="165" y2="310" stroke="#222122b7" strokeWidth="2" opacity="0.5" strokeDasharray="5,5" />
      <line x1="270" y1="250" x2="335" y2="310" stroke="#222122b7" strokeWidth="2" opacity="0.5" strokeDasharray="5,5" />
      
      {/* Microphone icon - Top Left */}
      <g transform="translate(100, 120)" opacity="0.6">
        <rect x="-15" y="-30" width="30" height="40" rx="15" fill="#164be8ff" />
        <line x1="0" y1="10" x2="0" y2="35" stroke="#164be8ff" strokeWidth="3" strokeLinecap="round" />
        <path d="M -20 35 L 20 35" stroke="#164be8ff" strokeWidth="3" strokeLinecap="round" />
        <path d="M -25 0 Q -25 20 0 20 Q 25 20 25 0" stroke="#2e59d9" strokeWidth="2.5" fill="none" />
      </g>
      
      {/* Headset icon - Top Right */}
      <g transform="translate(400, 120)" opacity="0.6">
        <path d="M -30 0 Q -30 -35 0 -35 Q 30 -35 30 0" stroke="#164be8ff" strokeWidth="5" fill="none" strokeLinecap="round" />
        <rect x="-35" y="-5" width="15" height="25" rx="3" fill="#164be8ff" />
        <rect x="20" y="-5" width="15" height="25" rx="3" fill="#164be8ff" />
      </g>
      
      {/* Call routing arrows */}
      <g opacity="0.5">
        <path d="M 180 280 L 200 290" stroke="#222122b7" strokeWidth="2" markerEnd="url(#arrowhead)" />
        <path d="M 320 280 L 300 290" stroke="#222122b7" strokeWidth="2" markerEnd="url(#arrowhead)" />
      </g>
      
      {/* Arrow marker definition */}
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
          <polygon points="0 0, 10 3, 0 6" fill="#222122b7" />
        </marker>
      </defs>
    </svg>
  )
}

export default IVRIllustration